import { AuthUserQuery } from 'dashboard-services/api/auth';

import { useMutation, useQuery } from '@tanstack/react-query';

export default (() => {
  const useGetCurrentUserSettings = ({ getQueryBuilder, token, entitlements, userName, ...rest }) =>
    useQuery({
      ...AuthUserQuery.QUERIES.getCurrentUserSettings(
        getQueryBuilder,
        {
          token,
          entitlements,
          userName
        }
      ),
      refetchOnReconnect: false,
      refetchOnWindowFocus: false,
      ...rest
    })

  const useGetCurrentUserSettingsMutation = ({ getQueryBuilder, token, entitlements, ...rest }) =>
    useMutation({
      ...AuthUserQuery.QUERIES.getCurrentUserSettingsMutation(
        getQueryBuilder,
        {
          token,
          entitlements
        }
      ),
      ...rest
    })

  const useUpdateCurrentUserSettings = ({ getQueryBuilder, settings, ...rest }) => 
    useMutation({
      ...AuthUserQuery.QUERIES.updateCurrentUserSettings(
        getQueryBuilder,
        {
          settings
        }
      ),
      ...rest
    })

  return {
    useGetCurrentUserSettings,
    useUpdateCurrentUserSettings,
    useGetCurrentUserSettingsMutation
  }
})()